import React, { useState, useEffect, useMemo } from "react";
import { useTable, useGlobalFilter, usePagination } from "react-table";
import { GlobalFilter } from "../../../../components/partial/GlobalFilter"
import { connect } from "react-redux";
import InfiniteScroll from "react-infinite-scroll-component";
import debounce from "lodash.debounce";
import { clearRedemption, getRedemption } from "../../../../actions/redemption";
import { getCellAlignProps } from "../../../../utils/helper";

const Paginated = ({
    columns,
    data,
    Redemption,
    getRedemption,
    clearRedemption,
    loader,
    setLoader,
    serverPaginated = true, // true = point tab (API driven), false = voucher tab (client side)
}) => {
    const [selectPage, setSelectPage] = useState();
    const [selectedPageIndex, setSelectedPageIndex] = useState(1);
    const [pageArray, setPageArray] = useState();
    const [transactionCount, setTransactionCount] = useState();

    const { getTableProps, getTableBodyProps, headerGroups, rows, page, state, setPageSize, prepareRow, setGlobalFilter } = useTable(
        {
            columns,
            data,
            initialState: { pageSize: 50 },
        },
        useGlobalFilter,
        usePagination
    );

    const { globalFilter, pageSize } = state;
    const [inputField, setInputField] = useState(globalFilter);
    const [visibleRowCount, setVisibleRowCount] = useState(pageSize);
    const [tempValue, setTempValue] = useState("");

    const handleInputChange = (e) => {
        const value = e.target.value;
        setTempValue(value);
        setGlobalFilter(value);
        if (value === "" && serverPaginated) {
            const token = JSON.parse(localStorage.getItem("token_gen"));
            let tempPageIndex = JSON.parse(localStorage.getItem("CusPageIndex"));
            let id = localStorage.getItem("Id");
            getRedemption(token?.access_token, tempPageIndex, 50);
        }
    };
    const debouncedResults = useMemo((e) => {
        return debounce(handleInputChange, 50);
    }, []); // eslint-disable-line

    useEffect(() => {
        setGlobalFilter(inputField);
    }, [inputField]); // eslint-disable-line

    // ---- Server-paginated (Point tab) count/pages ----
    useEffect(() => {
        if (serverPaginated) {
            setTransactionCount(Redemption?.data?.totalCount);
        }
    }, [Redemption, serverPaginated]);

    useEffect(() => {
        if (serverPaginated) {
            if (transactionCount) {
                let tempTransactionCount = transactionCount / 50;
                let temp = Math.ceil(tempTransactionCount);
                setSelectPage(temp);
            } else {
                setSelectPage(0);
            }
        }
    }, [transactionCount, serverPaginated]);

    // ---- Client-paginated (Voucher tab) count/pages ----
    useEffect(() => {
        if (!serverPaginated) {
            const temp = Math.ceil((data?.length || 0) / 50);
            setSelectPage(temp);
            setSelectedPageIndex(1);
        }
        // eslint-disable-next-line
    }, [data, serverPaginated]);

    useEffect(() => {
        if (serverPaginated) {
            let tempPageIndex = JSON.parse(localStorage.getItem("TransPageIndex"));
            if (tempPageIndex !== 1) {
                fetch();
            }
        }
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        const temp = Array.from({ length: selectPage }, (_, index) => index + 1);
        setPageArray(temp);
    }, [selectPage]);

    useEffect(() => {
        if (serverPaginated) {
            let tempPageIndex = JSON.parse(localStorage.getItem("TransPageIndex"));
            tempPageIndex ? setSelectedPageIndex(tempPageIndex) : setSelectedPageIndex(1);
        }
        // eslint-disable-next-line
    }, []);

    const handlePageIndex = (event) => {
        if (event.target.value !== "") {
            const number = Number(event.target.value);
            setSelectedPageIndex(number);
            if (serverPaginated) {
                localStorage.setItem("TransPageIndex", JSON.stringify(number));
                fetch();
            }
        }
    };

    const fetch = async () => {
        if (!serverPaginated) return;
        setLoader(true);
        await clearRedemption();
        let tempPageIndex = JSON.parse(localStorage.getItem("TransPageIndex"));
        const token = JSON.parse(localStorage.getItem("token_gen"));
        let id = localStorage.getItem("Id");
        await getRedemption(token?.access_token, tempPageIndex, 50);
        setLoader(false);
    };

    const handleNext = () => {
        if (selectedPageIndex < pageArray?.length) {
            const nextIndex = selectedPageIndex + 1;
            setSelectedPageIndex(nextIndex);
            if (serverPaginated) {
                localStorage.setItem("TransPageIndex", JSON.stringify(nextIndex));
                fetch();
            }
        }
    };
    const handlePrevious = () => {
        if (selectedPageIndex > 1) {
            const prevIndex = selectedPageIndex - 1;
            setSelectedPageIndex(prevIndex);
            if (serverPaginated) {
                localStorage.setItem("TransPageIndex", JSON.stringify(prevIndex));
                fetch();
            }
        }
    };

    // For client-paginated mode: slice data locally per page
    const clientPagedRows = useMemo(() => {
        if (serverPaginated) return rows;
        const start = (selectedPageIndex - 1) * 50;
        const end = start + 50;
        return rows.slice(start, end);
    }, [serverPaginated, rows, selectedPageIndex]);

    const displayRows = serverPaginated ? rows.slice(0, visibleRowCount) : clientPagedRows;
    const totalCountLabel = serverPaginated
        ? Redemption?.data?.totalCount
        : data?.length;

    return (
        <>
            {loader && (
                <div className="mainPreloaderMain">
                    <div className="mainPreloader">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
            )}

            <div className="customTable">
                <div className="customTable__header">
                    <div className="customTable__left">
                    </div>
                </div>
                <div className="customTable__body">
                    <div className="table-responsive">
                        {data?.length ? (
                            serverPaginated ? (
                                <InfiniteScroll
                                    dataLength={visibleRowCount}
                                    next={() => {
                                        setVisibleRowCount((prevRowCount) => prevRowCount + pageSize);
                                    }}
                                    hasMore={visibleRowCount < rows.length}
                                >
                                    <table className="table table-striped table-bordered sticky_table" {...getTableProps()}>
                                        <thead>
                                            {headerGroups.map((headerGroup) => (
                                                <tr {...headerGroup.getHeaderGroupProps()}>
                                                    {headerGroup.headers.map((column) => (
                                                        <th {...column.getHeaderProps()}>{column.render("Header")}</th>
                                                    ))}
                                                </tr>
                                            ))}
                                        </thead>

                                        <tbody {...getTableBodyProps()}>
                                            {displayRows.map((row, rowIndex) => {
                                                prepareRow(row);
                                                return (
                                                    <tr {...row.getRowProps()} key={rowIndex}>
                                                        {row.cells.map((cell) => {
                                                            return <td {...getCellAlignProps(cell)}>{cell.render("Cell") ? cell.render("Cell") : "Null"}</td>;
                                                        })}
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </InfiniteScroll>
                            ) : (
                                <table className="table table-striped table-bordered sticky_table" {...getTableProps()}>
                                    <thead>
                                        {headerGroups.map((headerGroup) => (
                                            <tr {...headerGroup.getHeaderGroupProps()}>
                                                {headerGroup.headers.map((column) => (
                                                    <th {...column.getHeaderProps()}>{column.render("Header")}</th>
                                                ))}
                                            </tr>
                                        ))}
                                    </thead>

                                    <tbody {...getTableBodyProps()}>
                                        {displayRows.map((row, rowIndex) => {
                                            prepareRow(row);
                                            return (
                                                <tr {...row.getRowProps()} key={rowIndex}>
                                                    {row.cells.map((cell) => {
                                                        return <td {...getCellAlignProps(cell)}>{cell.render("Cell") ? cell.render("Cell") : "Null"}</td>;
                                                    })}
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            )
                        ) : (
                            <table className="table table-striped table-bordered sticky_table" {...getTableProps()}>
                                <thead>
                                    {headerGroups.map((headerGroup) => (
                                        <tr {...headerGroup.getHeaderGroupProps()}>
                                            {headerGroup.headers.map((column) => (
                                                <th {...column.getHeaderProps()}>{column.render("Header")}</th>
                                            ))}
                                        </tr>
                                    ))}
                                </thead>
                                <tbody>
                                    <tr>
                                        <td colSpan={12} style={{ textAlign: "center", display: "table-cell", textTransform: "Capitalize" }}>
                                            No data found
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        )}
                    </div>
                </div>
                <div className="customTable__footer">
                    <div className="customTable__left">
                        <div className="customTable__totalTransactions">
                            <p>
                                Total Transactions: <span>{totalCountLabel}</span>
                            </p>
                        </div>
                    </div>
                    <div className="customTable__right">
                        <div className="customTable__top">
                            <div className="customTable__totalPages">
                                {pageArray && (
                                    <p>
                                        Page
                                        <select className="form-control selectArrow" value={selectedPageIndex} onChange={handlePageIndex}>
                                            {pageArray.length ? (
                                                pageArray.map((value) => (
                                                    <option key={value} value={value}>
                                                        {value}
                                                    </option>
                                                ))
                                            ) : (
                                                <option key={1} value={1}>
                                                    {1}
                                                </option>
                                            )}
                                        </select>
                                        of{pageArray?.length ? (
                                            <span>{pageArray?.length}</span>) : <span>{1}</span>}
                                    </p>
                                )}
                            </div>
                        </div>
                        <div className="customTable__bottom">
                            <div className="customTable__buttons">
                                <span className="btn btn-outline-primary" onClick={() => handlePrevious()} disabled={selectedPageIndex > 1 ? false : true}>
                                    {"Previous"}
                                </span>
                                <span className="btn btn-outline-primary" onClick={handleNext} disabled={pageArray?.length > 0 ? (selectedPageIndex === pageArray?.length ? true : false) : true}>
                                    {"Next"}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
const mapStateToProps = (state) => ({
    Redemption: state.Redemption,
});
const mapDispatchToProps = {
    getRedemption,
    clearRedemption,
};

export default connect(mapStateToProps, mapDispatchToProps)(Paginated);